import { render, staticRenderFns } from "./ModalSendCheck.vue?vue&type=template&id=07a97972&"
import script from "./ModalSendCheck.vue?vue&type=script&lang=js&"
export * from "./ModalSendCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports